export const parseFieldErrors = (err) => {
  const data = err?.response?.data;
  if (!data) return {};

  const source = (data.errors && typeof data.errors === "object" && !Array.isArray(data.errors))
    ? data.errors
    : data;

  const errors = {};
  if (typeof source === "object" && !Array.isArray(source)) {
    for (const [key, value] of Object.entries(source)) {
      if (key === "message" || key === "detail" || key === "status_code" || key === "status") continue;
      if (Array.isArray(value)) {
        errors[key] = value[0];
      } else if (typeof value === "string") {
        errors[key] = value;
      }
    }
  }
  return errors;
};
